module.exports = __webpack_public_path__ + "static/media/dinglv7.f6909c44.png";